import { useState, useRef, useCallback } from "react";

export function useRefState(initialValue) {
  const [state, setState] = useState(initialValue);
  const ref = useRef(initialValue);

  const setStateAndRef = useCallback((value) => {
    ref.current = value;
    setState(value);
  }, []);

  return [state, setStateAndRef, ref];
}
